import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "lib/axios";

export const useReviewNewsletters = (): UseQueryResult<any[]> => {
  return useQuery({
    queryKey: ["newsletters-review"],
    queryFn: async () => {
      const { data } = await axios.get("/newsletters/review");
      return data.newsletters;
    },
  });
};
